// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --image-width: 175px;
}

.line1 {
  font-weight: 700;
  line-height: 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.item-price-container {
  background-color: var(--attentionBoxBackgroundColour);
  color: var(--textColour);
}

.time-left-container {
  background-color: rgba(38, 41, 101, 0.05);
  color: var(--textColour);
}

.auction-label {
  font-size: 1rem;
  font-weight: 600;
}

.tl-text {
  font-weight: 600;
  color: var(--textColour);
  font-size: 0.75rem;
}

.tl-value {
  font-weight: 600;
  color: var(--linkColour);
  font-size: 1rem;
  line-height: 1.1rem;
}

.image-box {
  width: 100%;
  height: calc(var(--image-width) / var(--aspectRatio));
  text-align: center;
  margin-top: 0px;
  position: relative;
}
.image-box .image-count {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 20px;
  z-index: 999;
  min-width: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  border-radius: 5px 0;
  padding: 0 3px 0 4px;
  font-size: 0.875rem;
  cursor: pointer;
  letter-spacing: -0.25px;
}
.image-box .your-advert {
  position: absolute;
  top: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  cursor: pointer;
  width: 100%;
  font-size: 0.75em;
  border-radius: 3px;
}
.image-box .non-runner {
  position: absolute;
  top: 0;
  text-align: center;
  background-color: var(--errorColour);
  color: #fff;
  cursor: pointer;
  width: 100%;
  font-size: 0.75em;
  border-radius: 3px;
}

.image {
  width: var(--image-width);
  height: calc(var(--image-width) / var(--aspectRatio));
  text-align: center;
  background-color: #eee;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: var(--vehicleMediaCoverOrContain);
  outline: 1px solid var(--imageOutlineColour);
}

.left-box {
  flex-grow: 0;
  flex-basis: var(--image-width);
  position: relative;
  box-sizing: content-box;
}

.vehicle-chip {
  padding: 3px 8px;
  font-size: 0.75rem;
  font-weight: 400;
  display: inline-block;
  margin-right: 9px;
  margin-bottom: 7px;
  background-color: var(--chipBackgroundColour);
  border-radius: 12px;
}

.under-image-box {
  vertical-align: top;
  height: 25px;
  position: relative;
}
.under-image-box .number-plate {
  display: inline-block;
  font-size: 0.85rem;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 3px;
  margin: 0 auto;
  background-color: var(--vrmBackgroundColourLight);
  font-weight: 600;
  position: absolute;
  right: 0px;
  padding: 0 5px;
  top: 0;
}
.under-image-box .watchlist-container {
  background-color: #eee;
  display: inline-block;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 50%;
  overflow-y: hidden;
  font-size: 20px;
  position: absolute;
  top: -15px;
  left: 5px;
  z-index: 999;
  cursor: pointer;
  box-shadow: 2px 2px 2px 0px rgba(50, 50, 50, 0.15);
}

.condition-report {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--textColour);
}
.condition-report i {
  color: var(--linkColour);
}

.right-section-table {
  display: grid;
  grid-gap: 1px;
  height: 100%;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  grid-template-rows: 25px;
  grid-auto-rows: 1fr;
  vertical-align: middle;
  align-items: center;
}
.right-section-table > div {
  text-align: center;
}

@media all and (max-width: 768px) {
  .vehicle-chip {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .left-box {
    min-width: 50%;
  }
  .left-box .image {
    width: 100%;
  }
  .right-section-table {
    grid-template-rows: 1fr;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
  }
}
.display-table {
  display: table;
  text-align: center;
  height: 100%;
}
.display-table .display-table-cell {
  display: table-cell;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.display-table .label {
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 0.9rem;
}
.display-table .value {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 0.9rem;
}

.center-section {
  flex-grow: 3;
  flex-basis: 360px;
  position: relative;
}

.vertical-table {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.summary-line .summary-inner {
  background-color: var(--attentionBoxBackgroundColour);
  border-radius: 8px 8px 0 0;
  font-size: 0.75rem;
  font-weight: 400;
  padding: 4px 8px;
  display: inline-block;
}

.sale-type-name {
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 0 5px 0 0;
}
.sale-type-name.sale-type-1 {
  background-color: var(--buyNowColour);
}
.sale-type-name.sale-type-2 {
  background-color: var(--managedSaleColour);
}
.sale-type-name.sale-type-3 {
  background-color: var(--timedSaleColour);
}
.sale-type-name.sale-type-4 {
  background-color: var(--underwriteColour);
}
.sale-type-name.saletype-withdrawn {
  background-color: var(--dangerColour);
}

.right-section {
  border-radius: var(--widgetBorderRadius) !important;
}

.valuation-container {
  color: var(--textColour);
}

.sale-data {
  font-weight: 400;
}

.valuation .label {
  font-size: 0.6rem;
  line-height: 0.6rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #99a;
}
.valuation .value {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--linkColour);
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/advert/advert-search-summary/advert-search-summary.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EAEE,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAAF;;AAIA;EACE,qDAAA;EACA,wBAAA;AADF;;AAIA;EACE,yCAAA;EACA,wBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;AADF;;AAIA;EAEE,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAFF;AAIE;EAEE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAHJ;AAME;EACE,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AASA;EACE,yBAAA;EACA,qDAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,kCAAA;EACA,kDAAA;EACA,4CAAA;AANF;;AAiBA;EAEE,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;AAfF;;AAmBA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6CAAA;EACA,mBAAA;AAhBF;;AAoBA;EAEE,mBAAA;EACA,YAAA;EACA,kBAAA;AAlBF;AAoBE;EAEE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iDAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,MAAA;AAnBJ;AAsBE;EACE,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,kDAAA;AApBJ;;AAwBA;EAEE,kBAAA;EACA,gBAAA;EACA,wBAAA;AAtBF;AAwBE;EAEE,wBAAA;AAvBJ;;AA4BA;EAEE,aAAA;EACA,aAAA;EACA,YAAA;EACA,0DAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,kBAAA;AA1BJ;;AA8BA;EAEE;IACE,iBAAA;IACA,kBAAA;EA5BF;EAgCA;IACE,cAAA;EA9BF;EAgCE;IACE,WAAA;EA9BJ;EAkCA;IACE,uBAAA;IACA,mBAAA;IACA,yDAAA;EAhCF;AACF;AAmCA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;AAjCF;AAmCE;EAEE,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAlCJ;AAqCE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AApCJ;;AAwCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AArCF;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AArCF;;AA0CE;EACE,qDAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAvCJ;;AA4CA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;AAzCF;AA2CE;EACE,qCAAA;AAzCJ;AA4CE;EACE,0CAAA;AA1CJ;AA6CE;EACE,wCAAA;AA3CJ;AA8CE;EACE,yCAAA;AA5CJ;AA+CE;EACE,qCAAA;AA7CJ;;AAiDA;EAEE,mDAAA;AA/CF;;AAmDA;EACE,wBAAA;AAhDF;;AAmDA;EACE,gBAAA;AAhDF;;AAqDE;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAlDJ;AAqDE;EACE,kBAAA;EACA,gBAAA;EACA,wBAAA;AAnDJ","sourcesContent":[":host {\n  --image-width: 175px;\n}\n\n.line1 {\n\n  font-weight: 700;\n  line-height: 1rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n\n}\n\n.item-price-container {\n  background-color: var(--attentionBoxBackgroundColour);\n  color: var(--textColour);\n}\n\n.time-left-container {\n  background-color: rgba(38, 41, 101, 0.05);\n  color: var(--textColour);\n}\n\n.auction-label {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.tl-text {\n  font-weight: 600;\n  color: var(--textColour);\n  font-size: 0.75rem;\n}\n\n.tl-value {\n  font-weight: 600;\n  color: var(--linkColour);\n  font-size: 1rem;\n  line-height: 1.1rem;\n}\n\n.image-box {\n\n  width: 100%;\n  height: calc(var(--image-width) / var(--aspectRatio));\n  text-align: center;\n  margin-top: 0px;\n  position: relative;\n\n  .image-count {\n\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    height: 20px;\n    z-index: 999;\n    min-width: 20px;\n    line-height: 20px;\n    text-align: center;\n    color: #fff;\n    border-radius: 5px 0;\n    padding: 0 3px 0 4px;\n    font-size: 0.875rem;\n    cursor: pointer;\n    letter-spacing: -0.25px;\n  }\n\n  .your-advert {\n    position: absolute;\n    top: 0;\n    text-align: center;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: #fff;\n    cursor: pointer;\n    width: 100%;\n    font-size: 0.75em;\n    border-radius: 3px;\n  }\n\n  .non-runner {\n    position: absolute;\n    top: 0;\n    text-align: center;\n    background-color: var(--errorColour);\n    color: #fff;\n    cursor: pointer;\n    width: 100%;\n    font-size: 0.75em;\n    border-radius: 3px;\n  }\n}\n\n.image {\n  width: var(--image-width);\n  height: calc(var(--image-width) / var(--aspectRatio));\n  text-align: center;\n  background-color: #eee;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: var(--vehicleMediaCoverOrContain);\n  outline: 1px solid var(--imageOutlineColour);\n}\n\n.advert-widget {\n\n  &:first-child {\n\n  }\n}\n\n\n.left-box {\n\n  flex-grow: 0;\n  flex-basis: var(--image-width);\n  position: relative;\n  box-sizing: content-box;\n\n}\n\n.vehicle-chip {\n  padding: 3px 8px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  display: inline-block;\n  margin-right: 9px;\n  margin-bottom: 7px;\n  background-color: var(--chipBackgroundColour);\n  border-radius: 12px;\n}\n\n\n.under-image-box {\n\n  vertical-align: top;\n  height: 25px;\n  position: relative;\n\n  .number-plate {\n\n    display: inline-block;\n    font-size: 0.85rem;\n    height: 25px;\n    line-height: 25px;\n    text-align: center;\n    border-radius: 3px;\n    margin: 0 auto;\n    background-color: var(--vrmBackgroundColourLight);\n    font-weight: 600;\n    position: absolute;\n    right: 0px;\n    padding: 0 5px;\n    top: 0;\n  }\n\n  .watchlist-container {\n    background-color: #eee;\n    display: inline-block;\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    text-align: center;\n    border-radius: 50%;\n    overflow-y: hidden;\n    font-size: 20px;\n    position: absolute;\n    top: -15px;\n    left: 5px;\n    z-index: 999;\n    cursor: pointer;\n    box-shadow: 2px 2px 2px 0px rgb(50 50 50 / 15%);\n  }\n}\n\n.condition-report {\n\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--textColour);\n\n  i {\n\n    color: var(--linkColour);\n\n  }\n}\n\n.right-section-table {\n\n  display: grid;\n  grid-gap: 1px;\n  height: 100%;\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  grid-template-rows: 25px;\n  grid-auto-rows: 1fr;\n  vertical-align: middle;\n  align-items: center;\n\n  & > div {\n    text-align: center;\n  }\n}\n\n@media all and (max-width: 768px) {\n\n  .vehicle-chip {\n    margin-right: 5px;\n    margin-bottom: 5px;\n\n  }\n\n  .left-box {\n    min-width: 50%;\n\n    .image {\n      width: 100%;\n    }\n  }\n\n  .right-section-table {\n    grid-template-rows: 1fr;\n    grid-auto-rows: 1fr;\n    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));\n  }\n}\n\n.display-table {\n  display: table;\n  text-align: center;\n  height: 100%;\n\n  & .display-table-cell {\n\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n    height: 100%;\n  }\n\n  .label {\n    font-weight: 500;\n    font-size: 0.75rem;\n    line-height: 0.9rem;\n  }\n\n  .value {\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 0.9rem;\n  }\n}\n\n.center-section {\n  flex-grow: 3;\n  flex-basis: 360px;\n  position: relative;\n}\n\n.vertical-table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.summary-line {\n\n  .summary-inner {\n    background-color: var(--attentionBoxBackgroundColour);\n    border-radius: 8px 8px 0 0;\n    font-size: 0.75rem;\n    font-weight: 400;\n    padding: 4px 8px;\n    display: inline-block;\n  }\n\n}\n\n.sale-type-name {\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 0 5px 0 0;\n\n  &.sale-type-1 {\n    background-color: var(--buyNowColour)\n  }\n\n  &.sale-type-2 {\n    background-color: var(--managedSaleColour)\n  }\n\n  &.sale-type-3 {\n    background-color: var(--timedSaleColour)\n  }\n\n  &.sale-type-4 {\n    background-color: var(--underwriteColour)\n  }\n\n  &.saletype-withdrawn {\n    background-color: var(--dangerColour);\n  }\n}\n\n.right-section {\n\n  border-radius: var(--widgetBorderRadius) !important;\n\n}\n\n.valuation-container {\n  color: var(--textColour);\n}\n\n.sale-data {\n  font-weight: 400;\n}\n\n.valuation {\n\n  .label {\n    font-size: 0.6rem;\n    line-height: 0.6rem;\n    text-transform: uppercase;\n    font-weight: 500;\n    color: #99a;\n  }\n\n  .value {\n    font-size: 0.85rem;\n    font-weight: 500;\n    color: var(--linkColour);\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
